
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 448 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"m433.9 65.9-51.9-51.9a48 48 0 0 0 -33.9-14h-172.1c-26.5 0-48 21.5-48 48v48h-80c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-48h80c26.5 0 48-21.5 48-48v-268.1a48 48 0 0 0 -14.1-33.9zm-167.9 398.1h-212a6 6 0 0 1 -6-6v-308a6 6 0 0 1 6-6h74v224c0 26.5 21.5 48 48 48h96v42a6 6 0 0 1 -6 6zm128-96h-212a6 6 0 0 1 -6-6v-308a6 6 0 0 1 6-6h106v88c0 13.3 10.7 24 24 24h88v202a6 6 0 0 1 -6 6zm6-256h-64v-64h9.6c1.6 0 3.1.6 4.2 1.8l48.4 48.4a6 6 0 0 1 1.8 4.2z"}})])
          )
        }
      }
    